module.exports = __webpack_public_path__ + "static/media/BNW_Alphabet_V.5bc20407.jpg";